import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type BlogAuthorListItem = ResultOf<
  typeof blogAuthorListQuery
>["blogAuthors"][number];

export const blogAuthorListQuery = graphql(`
  query BlogAuthorList {
    blogAuthors {
      id
      name
      role
      bio
      image {
        ...MediaFields
      }
    }
  }
`);

export const blogAuthorRecordQuery = graphql(`
  query BlogAuthorRecord($id: ID!) {
    blogAuthor(id: $id) {
      id
      name
      role
      bio
      image {
        ...MediaFields
      }
    }
  }
`);

export const createBlogAuthorMutation = graphql(`
  mutation CreateBlogAuthor($input: CreateBlogAuthorInput!) {
    createBlogAuthor(input: $input) {
      id
      name
      role
      bio
      image {
        ...MediaFields
      }
    }
  }
`);

export const updateBlogAuthorMutation = graphql(`
  mutation UpdateBlogAuthor($id: ID!, $input: UpdateBlogAuthorInput!) {
    updateBlogAuthor(id: $id, input: $input) {
      id
    }
  }
`);

export const deleteBlogAuthorMutation = graphql(`
  mutation DeleteBlogAuthor($id: ID!) {
    deleteBlogAuthor(id: $id) {
      id
    }
  }
`);
